import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from '@mui/material';
import { MouseEvent, useMemo, useRef, useState } from 'react';
import { usePostHog } from 'posthog-js/react';
import { useTranslation } from 'react-i18next';
import Markdown from '../../ui/Markdown';

const INFO_ITEMS: string[] = ['faq', 'webinair', 'methodology', 'about'];

const InfoMenu = () => {
  const iconRef = useRef<HTMLButtonElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeDialog, setActiveDialog] = useState<string | null>(null);
  const { t } = useTranslation(['common']);
  const posthog = usePostHog();

  const activeItem = useMemo(
    () => INFO_ITEMS.find((i) => i === activeDialog) ?? null,
    [activeDialog],
  );

  const handleMenuOpen = (event: MouseEvent<HTMLButtonElement>) => {
    posthog?.capture('menu_info clicked', {
      button_name: 'menu_info',
      page_name: 'header',
    });
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const handleOpenDialog = (key: string) => {
    handleMenuClose();
    posthog?.capture(`menu_info_${key} clicked`, {
      button_name: `menu_info_${key}`,
      page_name: 'header',
    });
    if (key === 'faq') {
      window.open('/faq', '_blank', 'noopener,noreferrer');
      return;
    }
    setActiveDialog(key);
  };

  const handleCloseDialog = () => {
    setActiveDialog(null);
  };

  return (
    <>
      <Tooltip title="Informations">
        <Avatar
          component="button"
          type="button"
          ref={iconRef}
          onClick={handleMenuOpen}
          sx={{
            width: 40,
            height: 40,
            backgroundColor: 'var(--VANILLA)',
            color: 'black',
            fontWeight: 600,
            fontSize: 22,
            cursor: 'pointer',
            border: 0,
            padding: 0,
          }}
        >
          i
        </Avatar>
      </Tooltip>

      <Menu
        id="info-menu"
        open={menuOpen}
        anchorEl={iconRef.current}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {INFO_ITEMS.map((key) => (
          <MenuItem key={key} onClick={() => handleOpenDialog(key)}>
            <ListItemText>{t(`common:informations.${key}.label`) || ''}</ListItemText>
          </MenuItem>
        ))}
      </Menu>

      <Dialog
        open={activeDialog !== null}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>{t(`common:informations.${activeItem}.label`) || ''}</DialogTitle>
        <DialogContent dividers>
          <Markdown>
            {t(`common:informations.${activeItem}.content`) || ''}
          </Markdown>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} variant="contained">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default InfoMenu;
